import {
  Accordion as MuiAccordion,
  AccordionProps as MuiAccordionProps,
  accordionClasses,
} from '@mui/material'
import styled from 'styled-components'

export type AccordionPropsType = MuiAccordionProps

const Accordion = styled(MuiAccordion)<AccordionPropsType>``

export { accordionClasses }
export default Accordion
